import {ConfiguratorProduct} from "App/services/api";
import {FetchAction, FetchState} from "App/services";
import {ActionType} from "App/constants";

export interface State {
    prodId: number
    configuration: ConfiguratorProduct
}

export function reducer(state: State | null = null, action: FetchAction) {
    switch (action.type) {
        case ActionType.FETCH_CONFIGURATORPRODUCT: {
            switch (action.state) {
                case FetchState.SUCCESS: {
                    return {
                        prodId: <number>action.params,
                        configuration: action.payload
                    }
                }
                default:
                    return state;
            }
        }
        case ActionType.PAGE_MAIN: {
            return null;
        }
        case ActionType.PAGE_CATEGORY: {
            return null;
        }
        case ActionType.PAGE_SUBCATEGORY: {
            return null;
        }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/services/reducers/configurations.ts